export const html2base64 = (pHtml) => {
  return new Promise((resolve, reject) => {
    const html = document.createElement('div')

    html.innerHTML = pHtml

    const xmlSerializer = new XMLSerializer()
    const xhtml = xmlSerializer.serializeToString(html)

    const svg = `<svg id="mySvg" xmlns="http://www.w3.org/2000/svg" height="265px" width="450px"><foreignObject height="265px" width="450px">${xhtml}</foreignObject></svg>`

    let url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
    const image = document.createElement('img')
    image.onload = function () {
      const canvas = document.createElement('canvas')
      canvas.height = 265
      canvas.width = 450
      const ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0)
      const data = canvas.toDataURL('image/png;base64;')
      resolve(data)
    }

    image.src = url
  })
}
